import React, { useContext, useEffect } from 'react'
import { AuthSessionContext } from 'api/AuthSession'
import { Navigate, Outlet } from 'react-router-dom'

const AuthRoute = ({ redirectPath = '/signin', children }) => {
    const isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated'))
    const { getSession } = useContext(AuthSessionContext)

    useEffect(() => {
        getSession()
    }, [])

    if (!isAuthenticated) {
        return <Navigate to={redirectPath} replace />
    }

    return <>{isAuthenticated ? children : <Outlet />}</>
}

export default AuthRoute
